import { onMounted, onUnmounted } from "vue";
import { Toast } from "vant";
import WindowLib from "@/lib/windowLib/WindowLib";

/**
 * NFC 读取 Hook
 *
 * 与原生 App 约定：原生监听到 NFC 标签后，调用 window.getNfcDataNativeFn(params)，
 * params 即识别到的码内容（字符串）。
 *
 * 用法：
 *   useNfc((params) => {
 *     form.value.code_sn = params;
 *     submitFormEle.value.submit();
 *   });
 *
 * 内部自动处理 onMounted 注册 / onUnmounted 移除，页面无需关心生命周期。
 * params 为空时统一 Toast.fail("nfc获取的数据为空")。
 */
export const useNfc = callback => {
  const winLib = new WindowLib();

  function getNfcData(params) {
    if (!params) {
      return Toast.fail("nfc获取的数据为空");
    }
    callback && callback(params);
  }

  onMounted(() => {
    winLib.addAttr("getNfcData", getNfcData);
  });

  onUnmounted(() => {
    winLib.removeAttr("getNfcData");
  });

  return {};
};
